import { alpha, lighten } from '@mui/material';
export const timeInputsSX = (theme) => {
    if (theme.palette.mode === 'light')
        return null;
    return {
        '& input[type="time"]::-webkit-calendar-picker-indicator': {
            colorScheme: 'dark',
        },
    };
};
export const calendarSX = (theme) => {
    const dark = theme.palette.mode === 'dark';
    const bgHoverLight = alpha(theme.palette.primary.main, 0.25);
    const rangeLight = alpha(theme.palette.primary.light, 0.7);
    const rangeHoverLight = lighten(theme.palette.primary.main, 0.2);
    const dayRadius = '25%';
    const monthRadius = '20px';
    const bg = 'background.paper';
    const bgHover = dark ? 'background.default' : bgHoverLight;
    const range = dark ? 'primary.dark' : rangeLight;
    const rangeHover = dark ? 'primary.main' : rangeHoverLight;
    const text = 'text.primary';
    const textWeekend = 'error.main';
    return {
        '& [class*="react-calendar"]': {
            color: text,
            backgroundColor: bg,
            border: 'none',
        },
        '& .react-calendar__month-view': {
            height: '330px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        '& .react-calendar__month-view__days__day--weekend': {
            color: textWeekend,
        },
        '& .react-calendar__tile--active.react-calendar__month-view__days__day--weekend': {
            color: text,
        },
        '& .react-calendar__tile--hover.react-calendar__month-view__days__day--weekend': {
            color: text,
        },
        '& .react-calendar__month-view__weekdays__weekday abbr': {
            textDecoration: 'none',
        },
        '& .react-calendar__navigation button': {
            '&:disabled': {
                backgroundColor: bg,
            },
            '&:enabled': {
                '&:focus': {
                    backgroundColor: bg,
                },
                '&:hover': {
                    backgroundColor: bgHover,
                },
            },
        },
        '& .react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from': {
            background: 'none',
        },
        '& .react-calendar__tile': {
            height: '50px',
            '&:disabled': {
                backgroundColor: bg,
                opacity: '0.5',
                pointerEvents: 'none',
            },
            '&:enabled': {
                '&:focus, :hover': {
                    backgroundColor: bgHover,
                    borderRadius: dayRadius,
                },
            },
            '&--range:enabled': {
                '&:focus, :hover': {
                    borderRadius: '0',
                },
            },
            '&--rangeStart:enabled, &--rangeEnd:enabled': {
                '&:focus, :hover': {
                    borderRadius: dayRadius,
                },
            },
        },
        '& .react-calendar__year-view__months__month.react-calendar__tile': {
            height: '80px',
            '&:enabled': {
                '&:focus, :hover': {
                    borderRadius: monthRadius,
                },
            },
            '&--range:enabled': {
                '&:focus, :hover': {
                    borderRadius: '0',
                },
            },
            '&--rangeStart:enabled, &--rangeEnd:enabled': {
                '&:focus, :hover': {
                    borderRadius: monthRadius,
                },
            },
        },
        '& .react-calendar__tile--now': {
            position: 'relative',
            '&::after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                height: '100%',
                width: '100%',
                top: '0',
                left: '0',
                border: 2,
                borderColor: rangeHover,
                borderRadius: dayRadius,
            },
        },
        '& .react-calendar__year-view__months__month.react-calendar__tile--now': {
            '&::after': {
                borderRadius: monthRadius,
            },
        },
        '& .react-calendar__tile--range': {
            position: 'relative',
            backgroundColor: range,
            '&:enabled': {
                '::after': {
                    content: '""',
                    display: 'none',
                    backgroundColor: rangeHover,
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    top: '0',
                    left: '0',
                    borderRadius: dayRadius,
                },
                '&:focus, :hover': {
                    backgroundColor: range,
                    '::after': {
                        display: 'block',
                    },
                },
            },
            '& abbr': {
                position: 'relative',
                zIndex: '5',
            },
        },
        '& .react-calendar__year-view__months__month.react-calendar__tile--range': {
            '&:enabled': {
                '::after': {
                    borderRadius: monthRadius,
                },
            },
        },
        '& .react-calendar__tile--rangeStart, .react-calendar__tile--rangeEnd': {
            borderRadius: dayRadius,
            backgroundColor: rangeHover,
            overflow: 'visible !important',
            '&::before': {
                content: '""',
                display: 'block',
                backgroundColor: range,
                position: 'absolute',
                height: '100%',
                width: '50%',
                top: '0',
                left: '50%',
            },
            '&::after': {
                content: '""',
                display: 'block !important',
                backgroundColor: rangeHover,
                position: 'absolute',
                height: '100%',
                width: '100%',
                top: '0',
                left: '0',
                borderRadius: dayRadius,
            },
        },
        '& .react-calendar__tile--rangeEnd': {
            '&::before': {
                left: '0',
            },
        },
        '& .react-calendar__tile--hasActive': {
            borderRadius: dayRadius,
            backgroundColor: rangeHover,
            overflow: 'visible !important',
            '&:focus, :hover': {
                backgroundColor: `${rangeHover} !important`,
            },
        },
        '& .react-calendar__year-view__months__month.react-calendar__tile--rangeStart, .react-calendar__year-view__months__month.react-calendar__tile--rangeEnd': {
            borderRadius: monthRadius,
            '&::after': {
                borderRadius: monthRadius,
            },
        },
        '& .react-calendar__tile--rangeBothEnds::before': {
            display: 'none',
        },
        '& .react-calendar__tile.react-calendar__tile--hover': {
            backgroundColor: bgHover,
        },
        '& .react-calendar__tile--hoverStart, .react-calendar__tile--hoverEnd': {
            borderRadius: dayRadius,
            backgroundColor: rangeHover,
            position: 'relative',
            overflow: 'visible !important',
            '& abbr': {
                position: 'relative',
                zIndex: '5',
            },
            '&::before': {
                content: '""',
                display: 'block',
                backgroundColor: bgHover,
                position: 'absolute',
                height: '100%',
                width: '50%',
                top: '0',
                left: '50%',
            },
            '&::after': {
                content: '""',
                display: 'block',
                backgroundColor: rangeHover,
                position: 'absolute',
                height: '100%',
                width: '100%',
                top: '0',
                left: '0',
                borderRadius: dayRadius,
            },
        },
        '& .react-calendar__tile--hoverEnd': {
            '&::before': {
                left: '0',
            },
        },
        '& .react-calendar__year-view__months__month.react-calendar__tile--hoverStart, .react-calendar__year-view__months__month.react-calendar__tile--hoverEnd': {
            borderRadius: monthRadius,
            '&::after': {
                borderRadius: monthRadius,
            },
        },
        '& .react-calendar__tile--hoverBothEnds::before': {
            display: 'none',
        },
    };
};
